import { gql } from '@apollo/client';

export const RESEND_RETURN_METHOD_EMAIL = gql`
  mutation ResendReturnMethodEmail($orderId: ID!) {
    __typename
    resendReturnMethodEmail(orderId: $orderId) {
      ... on ResendEmailSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
